import {
  BooleanField,
  EditButton,
  ListButton,
  Show,
  SimpleShowLayout,
  TextField,
  TopToolbar,
} from "react-admin";

import { MODULE_NAMES } from "@/constants/modules";
import { ReferenceField } from "@/fields/ReferenceField";

import { RadiusVpnServerPrivacyTypeField } from "./RadiusVpnServerPrivacyTypeField";

const ShowActions = () => (
  <TopToolbar sx={{ justifyContent: "space-between" }}>
    <ListButton />
    <EditButton />
  </TopToolbar>
);

export const RadiusVpnServersShow = () => (
  <Show actions={<ShowActions />}>
    <SimpleShowLayout>
      <TextField source="id" sortable={false} />
      <TextField source="createdAt" />
      <TextField source="updatedAt" />
      <TextField source="ip" sortable={false} />
      <ReferenceField
        module={MODULE_NAMES.DATA_CENTERS}
        label="Data Center"
        source="dataCenter.id"
      />
      <ReferenceField
        module={MODULE_NAMES.COUNTRIES}
        label="Country"
        source="country.id"
      />
      <ReferenceField
        module={MODULE_NAMES.CITIES}
        label="City"
        source="city.id"
      />
      <RadiusVpnServerPrivacyTypeField source="privacyType" />
      <ReferenceField
        module={MODULE_NAMES.ACCESS_LEVELS}
        label="Access Level"
        source="accessLevel.id"
      />
      <BooleanField source="active" />
      <TextField source="host" />
      <TextField source="protocolsCsv" />
      <BooleanField source="alive" />
      <BooleanField source="autoCreated" />
    </SimpleShowLayout>
  </Show>
);
